import React from 'react'
import { H4 } from '../../../../../../../../../../../Styles/typography'
import ArtistInfo from '../../../../../../../../../../../Components/artist-info'
import CourseStore from '../../../../../../../../../Store/CourseStore'
import { Subscribe } from 'unstated'
import { ArtistEl } from '../../elements'

const Artists = () => {
  return (
    <Subscribe
     to={[CourseStore]}>
        {({state: {coHosts,livDemyID}})=>{
            return (
            <ArtistEl>
                <ArtistInfo livdemyId={livDemyID} />
              {coHosts.map((coHost) => (
                  <ArtistInfo key={coHost.livdemyId} livdemyId={coHost.livdemyId} />
                ))}
                </ArtistEl>
        )}}
    </Subscribe>
  )
}

export default Artists